import api from "./api.service";

const API_SUFFIX = process.env.VUE_APP_API_SUFFIX;

export default class extends api {
  static media(startAt = 0, numberToGet = 10, searchTerm = -1, tags = -1) {
    let commaDelimTags = -1;
    if (tags.length > 0) {
      commaDelimTags = tags.join(",");
    }
    return this.apiRequest(
      API_SUFFIX +
        "/api/media/" +
        startAt +
        "/" +
        numberToGet +
        "/" +
        searchTerm +
        "/" +
        commaDelimTags,
      {},
      "GET"
    );
  }

  static getUsersPublicMedia(userId) {
    return this.apiRequest(
      API_SUFFIX + "/api/view-user/" + userId + "/media",
      {},
      "GET"
    );
  }

  static mediaItem(uuidId) {
    return this.apiRequest(API_SUFFIX + "/api/media-item/" + uuidId, {}, "GET");
  }

  static myMedia(startAt = 0, numberToGet = 10) {
    return this.apiRequest(
      API_SUFFIX + "/api/me/media/" + startAt + "/" + numberToGet,
      {},
      "GET"
    );
  }

  static mediaTags() {
    return this.apiRequest(API_SUFFIX + "/api/tags", {}, "GET");
  }

  static mediaTagsInUse() {
    return this.apiRequest(API_SUFFIX + "/api/tagsInUse", {}, "GET");
  }

  static favouritedMedia() {
    return this.apiRequest(API_SUFFIX + "/api/me/media/favourites", {}, "GET");
  }

  static toggleFavouriteMedia(mediaId) {
    return this.apiRequest(
      API_SUFFIX + "/api/me/media/favourite/" + mediaId,
      {},
      "POST"
    );
  }

  static changePrivacyLevel(data, mediaId) {
    return this.apiUpload(
      API_SUFFIX + "/api/media-item/" + mediaId + "/privacy/edit",
      data,
      "POST"
    );
  }

  static editMedia(data, mediaId) {
    return this.apiUpload(
      API_SUFFIX + "/api/media-item/" + mediaId + "/edit",
      data,
      "POST"
    );
  }

  static uploadMedia(formData) {
    return this.apiUpload(API_SUFFIX + "/api/me/media/upload", formData);
  }

  static deleteMedia(mediaId) {
    return this.apiUpload(
      API_SUFFIX + "/api/media-item/" + mediaId + "/delete",
      {},
      "POST"
    );
  }

  static getUsersFavouritedScenarios(userId) {
    return this.apiRequest(
      API_SUFFIX + "/api/user/" + userId + "/media/favourites",
      {},
      "GET"
    );
  }

  static downloadMedia(mediaId) {
    return this.apiRequest(
      API_SUFFIX + "/api/download/media/" + mediaId,
      {},
      "GET"
    );
  }
}
